import { Component, OnInit, OnDestroy, Input, Injectable } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../login/login.service';
// import { LoginSettings } from '../../login/LoginSetting.model';
import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
// import { MyReportsComponent } from '../my-reports/my-reports.component';
import { AutoRunSnapshot } from '../models/auto-run-report-snapshots.model';

import { ConfirmDeleteSnapshotComponent } from './confirm-delete-snapshot.component';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'reportSnapshots',
    templateUrl: './report-snapshots.component.html',
    styleUrls: ['./report-snapshots.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

@Injectable({
    providedIn: 'root',
})
export class ReportSnapshotsComponent implements OnInit, OnDestroy {

    @Input() confirmDeleteSnapshot: boolean;

    thisDialogRef: MatDialogRef<ReportSnapshotsComponent>;
    deleteSnapshotDialogRef: MatDialogRef<ConfirmDeleteSnapshotComponent>;

    selectedReport: Report;
    // selectedReportModuleId: number;
    // ReportModules: ReportModule[];
    IsReportSearch: boolean;
    allSnapshots: AutoRunSnapshot[] = [];
    selectedFolderId: number;
    selectedFolderName: string;


    SelectedSnapshotFolder: ReportFolder;
    // SelectedSnapshotReport: Report;

    reportFolders: ReportFolder[] = [];

    allReports: Report[] = [];
    sortedReports: Report[] = [];

    // get sortedDistinctReports(): Report[] {

    //     const distinctReports: number[] = [];
    //     const unsortedDistinctReports: Report[] = [];

    //     for (let i = 0; i < this.allReports.length; i++) {
    //         // if (!distinctReports.includes(this.allReports[i].IsSysGen)) {
    //         //     distinctReports.push(this.allReports[i].IsSysGen);
    //         //     unsortedDistinctReportNames.push(this.allReports[i].Name);
    //         // }
    //         if (this.selectedFolderName == 'All') {
    //             if (unsortedDistinctReports.find(r => r.Name == this.allReports[i].Name) == undefined)  {
    //                 unsortedDistinctReports.push(this.allReports[i]);
    //             }
    //         }
    //         else {
    //             unsortedDistinctReports.push(this.allReports[i]);
    //         }
    //     }

    //     //   console.log(unsortedDistinctReportNames.sort());

    //     this.sortedReports = unsortedDistinctReports.sort(this.compare);


    //     return this.sortedReports;
    // }

    snapshotCheckAll = false;

    constructor(
        reportSnapshotsDialogRef: MatDialogRef<ReportSnapshotsComponent>,
        private deleteSnapshotDialog: MatDialog,
        private reportService: ReportingService,
        private loginService: LoginService
    ) {

        this.thisDialogRef = reportSnapshotsDialogRef;
        this.selectedReport = reportService.SelectedReport;
        this.IsReportSearch = false;
        //        this.allSnapshots = this.selectedReport.Snapshots;
        // this.reportFolders = reportService.ReportFolders;
        this.selectedFolderId = reportService.selectedReportFolderId;
    }

    ngOnInit() {

        // reset this flag when coming back to snapshots
        this.reportService.snapshotDeleted = false;
        // we need to include the 'All' folder

        const allFolder = new ReportFolder();
        allFolder.Id = 0;
        allFolder.Name = 'All';
        allFolder.Order = -1;
        allFolder.Reports = [];
        this.reportFolders.push(allFolder); // we want this one first in the array

        const allReport = new Report();
        allReport.Id = 0;
        allReport.Name = 'All';
        allReport.ReportFolder = 'All';
        this.allReports.push(allReport);

        // we only want folders with reports AND SNAPSHOTS
        const reportFoldersWithReports: ReportFolder[] = [];
        for (let f = 0; f < this.reportService.ReportFolders.length; f++) {
            if (this.reportService.ReportFolders[f].Reports.length > 0) {
                let reportHasSnapshot = false;
                for (let r = 0; r < this.reportService.ReportFolders[f].Reports.length; r++) {
                    if (this.reportService.ReportFolders[f].Reports[r].Snapshots.length > 0) {
                        reportHasSnapshot = true;
                    }
                }
                if (reportHasSnapshot) {
                    reportFoldersWithReports.push(this.reportService.ReportFolders[f]);
                }
            }
        }

        // this.reportFolders = this.reportFolders.concat(this.reportService.ReportFolders);
        this.reportFolders = this.reportFolders.concat(reportFoldersWithReports);

        // we need to include the 'All' report option

        // const allReport = new Report();
        // allReport.Id = 0;
        // allReport.Name = 'All';
        // allReport.ReportFolder = 'All';
        // this.allReports.unshift(allReport); // we want this one first in the array

        if (this.reportService.inDebugMode) {
            console.log(this.reportService.ReportFolders);
            console.log(this.reportFolders);
        }

        // i is starting at 1 to avoid the 'All' folder
        for (let i = 1; i < this.reportFolders.length; i++) {
            if (this.reportFolders[i].Id == this.selectedFolderId) {
                this.SelectedSnapshotFolder = this.reportFolders[i];
                this.selectedFolderName = this.reportFolders[i].Name;
            }
            for (let r = 0; r < this.reportFolders[i].Reports.length; r++) {

                // we only want reports with saved snapshots
                if (this.reportFolders[i].Reports[r].Snapshots.length == 0) {
                    continue;
                }

                // we need to add the report to the 'All' folder
                const report = this.reportFolders[i].Reports[r];
                // report.ReportFolder = 'All';
                // this.reportFolders[0].Reports.push(report);
                this.reportFolders[0].Reports.push(this.getReportForAllFolder(report));

                // set the folder in the reports for filtering purposes
                this.reportFolders[i].Reports[r].ReportFolder = this.reportFolders[i].Name;

                // add reports to 'All' folder
                this.allReports.push(this.reportFolders[i].Reports[r]);


                for (let s = 0; s < this.reportFolders[i].Reports[r].Snapshots.length; s++) {
                    const snap = this.reportFolders[i].Reports[r].Snapshots[s];
                    if (this.reportFolders[i].Reports[r].ReportFolder == this.reportFolders[i].Name) {
                        snap.FolderName = this.reportFolders[i].Name;
                        snap.ReportName = this.reportFolders[i].Reports[r].Name;

                        // if (this.reportService.inDebugMode) {
                        //     console.log('this.reportFolders[' + i + '].Reports[' + r + '].Snapshots[' + s + ']');
                        //     console.log(snap);
                        // }
                    }
                    this.allSnapshots.push(snap);

                }

            }
            // setting All as default when coming from reports menu
            if (this.reportService.isReportsMenu) {
                this.selectedFolderName = 'All';
                this.selectedReport = allReport;
            }



        }

        // // we need to include the 'All' folder

        // const allFolder = new ReportFolder();
        // allFolder.Id = 0;
        // allFolder.Name = 'All';
        // allFolder.Order = -1;
        // this.reportFolders.unshift(allFolder); // we want this one first in the array

        // // we need to include the 'All' report option

        // const allReport = new Report();
        // allReport.Id = 0;
        // allReport.Name = 'All';
        // allReport.ReportFolder = 'All';
        // this.allReports.unshift(allReport); // we want this one first in the array

        // const allReport = new Report();
        // allReport.Id = 0;
        // allReport.Name = 'All';
        // allReport.ReportFolder = 'All';
        // this.allReports.push(allReport);

        // this.sortedDistinctReports = this.allReports.filter((x, i, a) => x && a.indexOf(x) === i);

        this.getsortedDistinctReports();

        if (this.reportService.inDebugMode) {
            console.log('allSnapshots');
            console.log(this.allSnapshots);
            console.log('this.reportFolders');
            console.log(this.reportFolders);

            console.log('this.allReports');
            console.log(this.allReports);
            console.log(this.sortedReports);
        }

    }

    ngOnDestroy() { }

    getsortedDistinctReports(): Report[] {

        const distinctReports: number[] = [];
        const unsortedDistinctReports: Report[] = [];


        for (let i = 0; i < this.allReports.length; i++) {
            // if (!distinctReports.includes(this.allReports[i].IsSysGen)) {
            //     distinctReports.push(this.allReports[i].IsSysGen);
            //     unsortedDistinctReportNames.push(this.allReports[i].Name);
            // }

            // console.log(unsortedDistinctReports.find(r => r.Name == this.allReports[i].Name));

            if (unsortedDistinctReports.find(r => r.Name == this.allReports[i].Name)) {

            }
            else {
                unsortedDistinctReports.push(this.allReports[i]);
            }
            // }
            // else {
            //     unsortedDistinctReports.push(this.allReports[i]);
            // }
        }

        //   console.log(unsortedDistinctReportNames.sort());

        this.sortedReports = unsortedDistinctReports.sort(this.compare);


        return this.sortedReports;
    }



    compare(a: Report, b: Report) {
        return a.Name.localeCompare(b.Name);
        // if (a.last_nom < b.last_nom)
        //   return -1;
        // if (a.last_nom > b.last_nom)
        //   return 1;
        // return 0;
    }

    //   objs.sort(compare);

    isSnapshotVisible(snap: AutoRunSnapshot): boolean {
        let isVisible = false;
        if (
            (snap.FolderName == this.selectedFolderName
                && snap.ReportName == this.selectedReport.Name)
            ||
            (this.selectedFolderName == 'All' && snap.ReportName == this.selectedReport.Name)
            ||
            (this.selectedFolderName == 'All' && this.selectedReport.Name == 'All')
        ) {
            isVisible = true;
        }
        return isVisible;
    }

    snapshotCheckAllClick(event?: boolean) {

        // if (this.reportService.inDebugMode) {
        //     // console.log(event);
        //     console.log(this.snapshotCheckAll);
        //     console.log(this.allSnapshots);
        // }

        for (let i = 0; i < this.allSnapshots.length; i++) {

            // we only want to check the visible checkboxes!
            if (this.isSnapshotVisible(this.allSnapshots[i])) {
                this.allSnapshots[i].IsSelected = this.snapshotCheckAll;
            }
            else {
                this.allSnapshots[i].IsSelected = false;
            }

        }

        if (this.reportService.inDebugMode) {
            console.log(this.allSnapshots);
        }
    }

    snapshotCheckClick(snap: AutoRunSnapshot, event?: boolean) {

        if (this.reportService.inDebugMode) {
            // console.log(event);
            console.log(this.snapshotCheckAll);
            console.log(this.allSnapshots);
        }
        // uncheck the All checkbox if ANY checkbox is unselected
        for (let i = 0; i < this.allSnapshots.length; i++) {

            if (!this.allSnapshots[i].IsSelected) {
                this.snapshotCheckAll = false; //  uncheck All
                break;
            }
        }

        //  we need to check the ALL checkbox if ALL other checkboxes are checked

        let allCheckBoxesAreChecked = true;


        for (let i = 0; i < this.allSnapshots.length; i++) {
            if (!this.allSnapshots[i].IsSelected) {
                allCheckBoxesAreChecked = false;
                break;
            }
        }

        this.snapshotCheckAll = allCheckBoxesAreChecked;


        if (this.reportService.inDebugMode) {
            console.log('snapshotCheckClick() END:');
            console.log(this.snapshotCheckAll);
        }

    }

    getReportForAllFolder(report: Report) {
        let newReport: Report;
        newReport = report;
        report.ReportFolder = 'All';
        return newReport;
    }


    selectedFolderChanged() {
        if (this.reportService.inDebugMode) {
            console.log(this.SelectedSnapshotFolder);
            console.log(this.selectedFolderName);
            console.log(this.allReports);
        }

        // default the reports to All??
        for (let i = 0; i < this.allReports.length; i++) {
            if (this.allReports[i].Name == 'All') {
                this.selectedReport = this.allReports[i];
            }
        }

        if (this.selectedFolderName == 'All') {
            // this.currencies = curr.filter((x, i, a) => x && a.indexOf(x) === i);
        }
    }

    getReportSnapshot(snap: AutoRunSnapshot) {

        this.reportService.getReportSnapshot(snap.AutoRunReportSnapshots_ID).subscribe(res => {

            // allow user to download the PDF
            ReportingService.saveFile(res, 'application/pdf', snap.ReportName + '.pdf');
            // dataBase64

        });

    }

    // deleteSelectedSnapshotsClick() {

    // }

    snapshotDeleteClick(snap: AutoRunSnapshot) {

        // todo: confirm delete

        if (this.reportService.inDebugMode) {
            console.log('snapshotDeleteClick()');
            console.log(this.confirmDeleteSnapshot);
        }

        this.reportService.autoRunSnapshot = snap;
        this.deleteSnapshotDialogRef = this.deleteSnapshotDialog.open(ConfirmDeleteSnapshotComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });


        this.deleteSnapshotDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('deleteSnapshotAfterClosed()');
                console.log(result);
                console.log(this.selectedReport);

            }

            // now lets remove it from our array
            for (let i = 0; i < this.allSnapshots.length; i++) {
                if (this.allSnapshots[i].AutoRunReportSnapshots_ID == result) {
                    this.allSnapshots.splice(i, 1);
                }
            }
        });


        // this.reportService.deleteReportSnapshot(snap.AutoRunReportSnapshots_ID).subscribe(res => {

        //     if (this.reportService.inDebugMode) {

        //     }
        // });



    }

    deleteSnapshotAfterClosed() {

        this.deleteSnapshotDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('deleteSnapshotAfterClosed()');
                console.log(result);
                console.log(this.selectedReport);
            }
        });
    }

    // snapshotFilter() {

    // }

    // getReportModules() {

    // }


    closeClick() {
        this.thisDialogRef.close(this.reportService.snapshotDeleted);
    }

} // end class